import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  add({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`policyInterpretation/add`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`policyInterpretation/findList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`policyInterpretation/findById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  update({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`policyInterpretation/update`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  delById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`policyInterpretation/delById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 添加隐私政策
  addPolicyApp({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`policyInterpretation/addPolicyApp`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 隐私政策列表
  findPolicyAppList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`policyInterpretation/findPolicyAppList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 删除隐私政策
  delPolicyAppById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`policyInterpretation/delPolicyAppById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 隐私政策
  findPolicyAppById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`policyInterpretation/findPolicyAppById`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updatePolicyApp({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`policyInterpretation/updatePolicyApp`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findContent({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`policyInterpretation/findContent`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
